import LegacySidebarComponentAdapter from './LegacySidebarComponentAdapter';
import { getSidebarCard } from './customerDataSidebarCards';
import { useCardRenderMarkers } from 'crm-cards-sdk/hooks/useCardRenderMarkers';
import CardContentLoadingComponent from 'crm-cards-sdk/components/skeletons/CardContentLoadingComponent';
import { jsx as _jsx } from "react/jsx-runtime";
function renderLoadingIndicator() {
  return /*#__PURE__*/_jsx(CardContentLoadingComponent, {});
}
function LegacySidebarCardContentAdapter(props) {
  const {
    objectTypeId,
    cardType,
    isSidebarWrapperLoading
  } = props;
  const {
    SuccessMarker,
    ErrorMarker
  } = useCardRenderMarkers();
  const CardComponent = getSidebarCard(cardType);
  const ContentComponent = CardComponent && CardComponent.Content ? CardComponent.Content : undefined;
  if (isSidebarWrapperLoading) {
    return /*#__PURE__*/_jsx(CardContentLoadingComponent, {});
  }
  if (ContentComponent && objectTypeId) {
    return /*#__PURE__*/_jsx(LegacySidebarComponentAdapter, Object.assign({
      CardComponent: ContentComponent,
      objectTypeId: objectTypeId,
      SuccessMarker: SuccessMarker,
      ErrorMarker: ErrorMarker,
      CardContentLoadingComponent: CardContentLoadingComponent,
      renderLoadingIndicator: renderLoadingIndicator
    }, props));
  }
  let errorCause = 'Unspecified Error Scenario';
  if (!CardComponent) {
    errorCause = `Missing CardComponent`;
  } else if (!objectTypeId) {
    errorCause = `Missing objectTypeId`;
  } else if (!ContentComponent) {
    errorCause = `Missing CardComponent.Content`;
  }
  throw new Error(`Unable to load Legacy Card Content for ${cardType}. Cause: ${errorCause}`);
}
export default LegacySidebarCardContentAdapter;